import { createUseStyles } from 'react-jss'

export const style = {
  container: {
    composes: 'flex-row flex-center-items report-text-block-width',
    padding: 30
  },
  choice: {
    composes: 'flex-row'
  },
  card: {
    composes: 'card',
    width: 200
  },
  cardText: {
    composes: 'card-description',
    marginBottom: 18,
    textAlign: 'center'
  },
  cardSeparator: {
    margin: 25,
    alignItems: 'center',
    display: 'flex',
    textTransform: 'uppercase',
    fontSize: 24,
    fontFamily: 'Raleway'
  }
}

export const useStyles = createUseStyles(style)
